import { render, staticRenderFns } from "./LandingPoint.vue?vue&type=template&id=32d8a4c6&scoped=true&"
import script from "./LandingPoint.vue?vue&type=script&lang=js&"
export * from "./LandingPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8a4c6",
  null
  
)

export default component.exports